export class SetRedirectUrl {
    static readonly type = '[Auth] SetRedirectUrl';

    constructor(public payload: string) {}
}
